@if (isLoading()) {
  <div class="sticky top-0 left-0 right-0 z-[200]">
    <div class="w-full absolute">
      <mat-progress-bar class="mds-x-small" [mode]="'indeterminate'"></mat-progress-bar>
    </div>
  </div>
}

<div class="h-full flex flex-col items-center justify-center">
  <div class="min-w-[100px] max-w-[300px] p-4">
    @switch (currentView()) {
      @case (view.LoadLicense) {
        <span class="mt-4 text-gray-8">{{ translations.loading.text }}</span>
      }
      @case (view.NoLicense) {
        <img src="../../../assets/no-license.png" class="w-full" alt="No license" />
        <div class="text-center text-sm h-36" data-cy="no-license-error">
          <div class="text-lg font-semibold mt-8 mb-2">{{ translations.noLicense.title.text }}</div>
          <div>{{ translations.noLicense.message.text }}</div>
        </div>
      }
      @case (view.AccountNotAllowed) {
        <img src="../../../assets/no-license.png" class="w-full" alt="Account not allowed" />
        <div class="text-center text-sm h-36" data-cy="account-not-allowed-error">
          <div class="text-lg font-semibold mt-8 mb-2">
            {{ translations.accountNotAllowed.title.text }}
          </div>
          <div>{{ translations.accountNotAllowed.message.text }}</div>
        </div>
      }
      @case (view.RegionNotAvailable) {
        <img src="../../../assets/no-region.svg" class="w-full" alt="Region not available" />
        <div class="text-center text-sm h-36" data-cy="region-not-available-error">
          <div class="text-lg font-semibold mt-8 mb-2">
            {{ translations.regionNotAvailable.title.text }}
          </div>
          <div>{{ regionNotAvailableMessage() }}</div>
        </div>
      }
      @case (view.UnknownError) {
        <img src="../../../assets/no-license.png" class="w-full" alt="Unknown error" />
        <div class="text-center text-sm h-36" data-cy="license-unknown-error">
          <div class="text-lg font-semibold mt-8 mb-2">
            {{ translations.unknownError.title.text }}
          </div>
          <div>{{ translations.unknownError.title.text }}</div>

          <button
            id="license-error-retry"
            class="mt-4"
            modus-flat-button
            [disabled]="isLoading()"
            (click)="reloadLicense()"
          >
            {{ translations.unknownError.retry.text }}
          </button>
        </div>
      }
    }
  </div>
</div>
